<div class='sidebar'>
    <img src="assets/images/logo-public.svg" alt="logo" class="logo">

    <div class="nav-menu">
        @for (item of items(); track item.route) {
            <div class='item'
                 #rla='routerLinkActive'
                 routerLinkActive='active'
                 role='button'
                 tabindex='0'
                 [routerLink]=[item.route]
                 (click)='itemClicked.emit(item)'
                 (keydown.enter)='itemClicked.emit(item)'
                 (keydown.space)='onSpace($event, item)'>

                <mat-icon>{{item.icon}}</mat-icon>
                <span>{{ item.name }}</span>
            </div>
        }
    </div>
    <div class="ng-content">
        <ng-content></ng-content>
    </div>
</div>
